import Box from '@mui/material/Box';

import { buildTabPanelA11yProps } from '../../utils/index';

export const TabPanel = (props: { children?: React.ReactNode; index: number | string; value: number | string }) => {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} {...buildTabPanelA11yProps(index)} {...other}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};
